module.exports = __webpack_public_path__ + "static/media/edelgard-vonhresvelg-icon.09a6e3a2.png";